import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreenEye = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_10833_12100)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M7.99935 2.66602C3.33268 2.66602 0.666016 7.99935 0.666016 7.99935C0.666016 7.99935 3.33268 13.3327 7.99935 13.3327C12.666 13.3327 15.3327 7.99935 15.3327 7.99935C15.3327 7.99935 12.666 2.66602 7.99935 2.66602Z",
				stroke: "#079E88",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
				stroke: "#079E88",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10833_12100",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGreenEye);
export { ForwardRef as ReactComponent };
